import { SwiperContainer } from 'swiper/element';

export class GalleryInitializer {
	init() {
		const seeGalleryButtons = document.querySelectorAll<HTMLElement>('.see-gallery');

		seeGalleryButtons.forEach((seeGalleryButton) => {
			seeGalleryButton.addEventListener('click', () => {
				const container = seeGalleryButton.closest('.text-container')?.parentElement;
				const gallerySlider = container?.querySelector<SwiperContainer>(
					'.gallery-slider-container swiper-container'
				);

				gallerySlider?.swiper.slideNext();
			});
		});

		const images = document.querySelectorAll<HTMLImageElement>('.gallery-slider-container swiper-slide img');
		const videos = document.querySelectorAll<HTMLImageElement>('.gallery-slider-container swiper-slide video');

		images.forEach((image) => {
			this.setMediaFileAspectRatio(image, 'image');
		});
		videos.forEach((video) => {
			this.setMediaFileAspectRatio(video, 'video');
		});
	}

	setMediaFileAspectRatio(file: HTMLImageElement | HTMLVideoElement, fileType: 'video' | 'image') {
		const slideWrapper = file.closest<HTMLElement>('.slide-wrapper')!;

		if (file instanceof HTMLImageElement) {
			if (file.complete) {
				handleImage(file);
			} else {
				file.onload = () => {
					handleImage(file);
				};
			}
		} else {
			if (file.readyState >= HTMLMediaElement.HAVE_ENOUGH_DATA) {
				handleImage(file);
			} else {
				file.onloadeddata = () => {
					handleImage(file);
				};
			}
		}

		handleImage(file);

		function handleImage(file: HTMLImageElement | HTMLVideoElement) {
			let aspectRatio;
			if (file instanceof HTMLImageElement) {
				const imageWidth = +file.getAttribute('width')!;
				const imageHeight = +file.getAttribute('height')!;
				aspectRatio = imageWidth / imageHeight;
			} else {
				aspectRatio = file.videoWidth / file.videoHeight;
			}

			slideWrapper.style.setProperty('--aspect-ratio', aspectRatio + '');
		}
	}
}
